import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderBody(h) {
  return h(
    'div',
    {
      class: 'px-2'
    },
    [
      h(
        info,
        {
          props: {
            value: this.$_content,
            color: this.color
          }
        }
      )
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat,
            disabled: this.loading
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.confirm'),
            color: this.color,
            loading: this.loading,
            disabled: this.loading || this.disabled
          },
          on: {
            click: this.callback
          }
        }
      )
    ]
  )
}

export default function(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = this.maxWidth
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.proxy,
        title: this.$_title,
        rounded: this.viewport.breakpoint.mdUp,
        maxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
